import styled from 'styled-components';
import { AlertContainer } from '../Alert/Alert.styles';
export const RegistrationContent = styled.div(({ $maxWidth }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: $maxWidth || '920px',
    width: '100%',
    padding: '24px',
    '& > h4': {
        marginBottom: '16px',
    },
    [AlertContainer]: {
        margin: '0 0 16px',
    },
}));
export const StepContainer = styled.div `
  align-self: flex-start;
  margin-bottom: 16px;
`;
